import React from 'react';

import Top from './generic';

const albums = props => (
  <Top title="Artists" url="/me/top/artists" type="artist" />
);

export default albums;
